import { createFileRoute, redirect } from "@tanstack/react-router";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { DocumentInboxClient } from "@/features/documents/DocumentInboxClient";
import { ScanFilesList } from "@/features/documents/ScanFilesList";
import type { DocumentsView } from "@/features/documents/documents.api";

// Transport → Alle documenten: the scans linked or put aside, and *Ingelezen*, the files the reader of WLX went through
// (docs/partner-portal.md §16). Reading takes documents; linking a scan, putting it aside or putting scans in takes
// dossiers_write. The scans without a consignment are the queue of Documentcontrole (docs/scantafel.md §13): whoever
// may open that goes there; the list here stays only for whoever reads scans without the orders.
export const Route = createFileRoute("/_shell/documents")({
  beforeLoad: ({ context, search }) => {
    if (!hasModule(context.session, "documents")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
    const orders = hasModule(context.session, "tms_orders") || hasModule(context.session, "tms_orders_write");
    if ((search.state === undefined || search.state === "open") && orders) throw redirect({ to: "/document-check" });
  },
  validateSearch: (search: Record<string, unknown>): { state?: DocumentsView } => ({
    state: (["open", "linked", "discarded", "files"] as const).find((state) => state === search.state),
  }),
  component: DocumentsScreen,
});

function DocumentsScreen() {
  const { state } = Route.useSearch();
  const navigate = Route.useNavigate();
  const { session } = Route.useRouteContext();
  const view = state ?? "open";
  const onView = (next: DocumentsView) => navigate({ search: { state: next === "open" ? undefined : next }, replace: true });
  const canWrite = hasModule(session, "dossiers_write");
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Documents">
      {view === "files" ? (
        <ScanFilesList userId={session.userId} onView={onView} canWrite={canWrite} />
      ) : (
        <DocumentInboxClient userId={session.userId} state={view} onView={onView} canWrite={canWrite} />
      )}
    </div>
  );
}
